import styled from 'styled-components';

export default styled.div`
  color: #738A94;
  font-size: 1.4rem;
  line-height: 150%;
  margin-left: 1rem;

  & > span {
    margin-left: 1rem;

    text-decoration: ${props => props.hasLineThrough ? 'line-through' : 'none'};
    color: ${props => props.hasLineThrough ? '#738A94' : '#058fe6'};
  }
`;
